import { handleActions } from 'redux-actions';
import * as Actions from '../actions/schoolAutoSuggestActions';

const app = handleActions({
  [Actions.setSchoolNames]: (state, action) => ({
    ...state,
    schoolNames: action.payload,
  }),
  [Actions.setLoadingSchoolNames]: (state, action) => ({
    ...state,
    loadingSchoolNames: action.payload,
  }),
}, {
  schoolNames: [],
  loadingSchoolNames: false,
});

export default app;
